import classNames from 'classnames';
import * as React from 'react';
import Icon from '../../../common/icons/Icon';

import css from './BooksDateCalendarHeader.module.scss';

interface Props {
  className?: string;
  baseDate: string;
  onClickPrev?: () => void;
  onClickNext?: () => void;
  prevButtonDisabled?: boolean;
}

const BooksDateCalendarHeader = ({
  className,
  onClickPrev,
  onClickNext,
  baseDate,
  prevButtonDisabled = false,
}: Props) => {
  const classes = classNames(css.BooksDateCalendarHeader, className);

  return (
    <div className={classes}>
      <button
        type="button"
        className={css.BooksDateCalendarHeader__Button}
        onClick={onClickPrev}
        disabled={prevButtonDisabled}
      >
        <Icon
          className={css.BooksDateCalendarHeader__Arrow}
          name="arrow-right"
        />
      </button>
      <div className={css.BooksDateCalendarHeader__Month}>{baseDate}</div>
      <button
        type="button"
        className={css.BooksDateCalendarHeader__Button}
        onClick={onClickNext}
      >
        <Icon
          className={css.BooksDateCalendarHeader__Arrow}
          name="arrow-right"
        />
      </button>
    </div>
  );
};

export default BooksDateCalendarHeader;
